import { ContentType } from '@candu-ai/content/types';

export enum Views {
  Overall = 'Overall',
  Segments = 'Segments',
  Goals = 'Goals',
  Components = 'Components',
}

export const VIEW_QUERY_PARAM = 'gvm';

export const tabs = [
  {
    key: Views.Overall,
    name: Views.Overall,
    displayName: {
      [ContentType.Tour]: 'Tours',
      [ContentType.HotspotGroup]: 'Hotspots',
    },
    queryParam: 'o',
  },
  {
    key: Views.Segments,
    name: Views.Segments,
    queryParam: 's',
  },
  {
    key: Views.Components,
    name: Views.Components,
    queryParam: 'c',
  },
  {
    key: Views.Goals,
    name: Views.Goals,
    queryParam: 'g',
  },
];
